import React, { Component } from 'react'
import Select from 'react-select';
import firebase from 'firebase' ;
import geofire from 'geofire';

class Cancelaciones extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cancelaciones:[],
            viajes:[],
            clientes:[],
            empleados:[]
        };
    }

    getData(){
        firebase.database().ref('Viaje').once('value').then(snapV =>{
            let viajes = [];
            snapV.forEach(element => {
                let datos = element.val();
                datos.key = element.key;
                viajes.push(datos)
            });
            firebase.database().ref('Clientes').once('value').then(snapC =>{
                let clientes = [];
                snapC.forEach(element => {
                    let datos = element.val();
                    datos.key = element.key;
                    clientes.push(datos)
                });
                firebase.database().ref('Empleados').once('value').then(snapE =>{
                    let empleados = [];
                    snapE.forEach(element => {
                        let datos = element.val();
                        datos.key = element.key;
                        empleados.push(datos)
                    });
                    this.setState({viajes, clientes, empleados})
                    this.getCancelaciones();
                })
            })
        })
    }

    componentDidMount(){
        this.getData();
    }
    

    reasignar = (data) =>{
        let viaje = data.viaje;
        firebase.database().ref('Empleados').once('value').then(snap =>{
            let posicionC = data.clientePos;
            let posicion = posicionC.split(',')
            let cercano = null;
            let distancia = 5000000.99;
            snap.forEach(element => {
                let conductor = element.val();
                if(conductor.latitud !== undefined){
                    conductor.key = element.key;
                    let act = [];
                    let comparar = [];
                    act.push(Number(posicion[0]));
                    act.push(Number(posicion[1]));
                    comparar.push(Number(conductor.latitud));
                    comparar.push(Number(conductor.longitud));
                    if (geofire.distance(act, comparar) < distancia && conductor.viaje !== 'activo' && conductor.viajeM !== 'activo' && conductor.estado === 'activo' && element.key !== data.viaje.empleado) {
                        cercano = conductor;
                        distancia = geofire.distance(act, comparar);
                    }
                }
            });
            firebase.database().ref().child('Empleados/' + data.viaje.empleado).update({
                viaje: 'desactivo',
                viajeActual: 'ninguno',
                viajeM: 'desactivo',
                viajeActualM: 'ninguno',
                ultimoV: data.viaje.key
              });
        
              firebase.database().ref().child('EmpleadosGPS/' + data.viaje.empleado).update({
                viaje: 'desactivo',
                viajeActual: 'ninguno',
                viajeM: 'desactivo',
                viajeActualM: 'ninguno',
                ultimoV: data.viaje.key
              });
            firebase.database().ref().child('Viaje/'+data.viaje.key).update({
                empleado:cercano.key,
                reasignado:true,
                notificaClienReas:false
            })
            firebase.database().ref().child('cancelaciones/'+data.key).update({
                estado:true,
                reemplazante:cercano.key
            })
        })
    }

    getCancelaciones = () =>{
        let {viajes, clientes, empleados} = this.state;
        firebase.database().ref('cancelaciones').on('value', snap =>{
            let cancelaciones = [];
            snap.forEach(element => {
                let dataC = element.val();
                dataC.key = element.key;
                if(dataC.reemplazante === ''){
                    let encontrardoViaje = viajes.find(emple => {
                        return dataC.viaje === emple.key;
                    })
                    if(encontrardoViaje !== undefined){
                        let encontrardoClinte = clientes.find(emple => {
                            return encontrardoViaje.cliente === emple.key;
                        })
                        let encontrardoConduct = empleados.find(emple => {
                            return encontrardoViaje.empleado === emple.key;
                        });
                        if (encontrardoConduct !== undefined) {
                            dataC.cliente = encontrardoClinte.nombre +' '+encontrardoClinte.apellido;
                            dataC.empleado = encontrardoConduct.nombre;
                            dataC.viaje = encontrardoViaje;
                            dataC.clientePos = encontrardoViaje.latitudInicial+','+encontrardoViaje.longuitudInicial;
                            let fecha = new Date(dataC.fechaSolicitud);
                            dataC.fechaI = fecha.getDate() +'/'+ (fecha.getMonth()+1) +'/'+ fecha.getFullYear();
                            dataC.horaI = fecha.getHours() +':'+ fecha.getMinutes();
                            cancelaciones.push(dataC);
                        }
                    }
                }
            });
            this.setState({cancelaciones});
        })
    }

    render() {
        let {cancelaciones} = this.state;
        return (
            <div>
                {/* 
                <div className="row top-margin-filtros">
                    <div className="col-12 col-md-6">
                        <form>
                            <div className="form-group row">
                                <label className="col-sm-2 col-form-label">Filtros</label>
                                <div className="col-sm-6">
                                    <Select onChange={this.addEmpreS} />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                */}
                <div className="row">
                    <div className="col-12">
                        <div className="table-responsive top-margin-table text-center">
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <th>Cliente</th>
                                        <th>Conductor</th>
                                        <th>Fecha</th>
                                        <th>Hora de solicitud</th>
                                        <th>Motivo</th>
                                        <th>Cancelar</th>
                                    </tr>
                                   {cancelaciones.map((snap, index) =>{
                                       return(
                                        <tr key={'cancelaciones'+index}>
                                            <td>{snap.cliente}</td>
                                            <td>{snap.empleado}</td>
                                            <td>{snap.fechaI}</td>
                                            <td>{snap.horaI}</td>
                                            <td>{snap.justificacion}</td>
                                            <td>
                                                <button onClick={()=>this.reasignar(snap)} className="btn btn-small-orange">Cancelar</button>
                                            </td>
                                        </tr>
                                       )
                                   })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default Cancelaciones;


// WEBPACK FOOTER //
// ./src/Components/Reservas/cancelaciones.js